import { useMemo } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let event_id = useDataValue({
    context: 'automation',
    path: 'event_id',
    viewPath: props.viewPath,
  })
  let selected_email = useDataValue({
    context: 'event_action',
    path: 'data.email_template.from',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'event_action',
    path: 'data.email_template.from',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    let default_email = data.comms_defaults[0]?.sender_id ?? null

    // if it is a new automation and default email is there. use that as default
    if (!event_id && default_email !== null && !selected_email) {
      change('DEFAULT')
    }

    return data.comms_outbound_emails.map(email => ({
      id: email.id === default_email ? 'DEFAULT' : email.id,
      text:
        email.id === default_email ? `Default (${email.email})` : email.email,
    }))
  }, [data])
}
